import { xMinValue } from "./xMinValue.js";
import { xRolling } from "./xRolling.js";
/**
 * This function calculates a minimum within a rolling window
 * @param array - array
 * @param options - options
 */
export function xRollingMin(array, options = {}) {
    return xRolling(array, xMinValue, options);
}
//# sourceMappingURL=xRollingMin.js.map